import { BASE_URL } from "../environment";
import makeRequest from "../makeRequest";

export default async function postZenOrder(body) {

  let isModelStateError = false;

  try {
  
    const results = await makeRequest(`${BASE_URL}/zenplaceorder`, {
      method: "POST",
      body,
    });

  const {ZenReference} = results || null;
  const {Message} = results || null;
  const {ModelState} = results || null;
  const {Errors} = results || null;
  const {ErrorMessage} = results || null;

    // Success
    if (ZenReference) {
      return ZenReference;
    }

    if (typeof results === "string") {
      throw "An unexpected error occurred. Please contact support.";
    }

    // Case 1: Model state errors (validation failed before order attempt)
    if (Message === "The request is invalid." && ModelState) {
      isModelStateError = true;
      throw ModelState;
    }

    // Case 2: Order failed to place due to backend failure
    if (Message?.toLowerCase().includes("failed to post order")) {
      throw "The availability may have become stale or an error occurred while placing the order. Please try again.";
    }

    // Case 3: Explicit errors from backend (e.g., expired availability)
    if (Array.isArray(Errors) && Errors.length) {
      throw Errors;
    }

    // Case 5: Any other error message — surface the actual message from the server
    if (ErrorMessage || (Message && !ZenReference)) {
      throw ErrorMessage || Message;
    }

    // Catch-all
    throw "An unknown error occurred. Please contact support. The order has not been placed.";

  } catch (err) {
    console.log(err);
    
    if (err && (typeof err === "string" || Array.isArray(err))) {
      throw err;
    }
  
    if (isModelStateError) {
      throw err;
    }
  
    throw "An unexpected error occurred. Please contact support.";
  }
}
